import _ from 'lodash';
import React, { Component } from 'react';
import { Dropdown, Icon, Input, Popup } from 'semantic-grab-ui/src';

interface Props {
  selectedEventName: string;
  eventTypesObject: {
    eventGroups: { [key: string]: any[] };
    rootEventTypes: any[];
  };
  handleEventSelection: (event: any, data: any, eventTypeData: any) => void;
  name: string;
}

interface State {
  searchQuery: string;
  isSearchMode: boolean;
}

// EventDropdown shows a two-level dropdown for event type selection with search capability
export default class EventDropdown extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      searchQuery: '',
      isSearchMode: false,
    };
  }

  handleSearchChange = (e: any, { value }: { value: string }) => {
    this.setState({
      searchQuery: value,
      isSearchMode: value.length > 0,
    });
  };

  handleItemSelection = (event: any, data: any, eventTypeData: any) => {
    // Clear search when item is selected
    this.setState({
      searchQuery: '',
      isSearchMode: false,
    });
    // Call the original handler
    this.props.handleEventSelection(event, { ...data, name: this.props.name }, eventTypeData);
  };

  getFilteredFlatOptions = () => {
    const { eventTypesObject } = this.props;
    const { searchQuery } = this.state;
    // Combine all events from groups and root events
    const allOptions = [
      ...eventTypesObject.rootEventTypes,
      ...Object.values(eventTypesObject.eventGroups).flat(),
    ];

    // Filter based on search query
    return allOptions.filter(eventData =>
      eventData.noun.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (eventData.description && eventData.description.toLowerCase().includes(searchQuery.toLowerCase())),
    );
  };

  render() {
    const { isSearchMode, searchQuery } = this.state;
    const renderEventItem = (eventTypeData: any) => (
      <Dropdown.Item
        key={eventTypeData.eventType}
        value={eventTypeData.eventType}
        onClick={(event, data) => this.handleItemSelection(event, data, eventTypeData)}
      >
        {`${eventTypeData.noun} `}
        {eventTypeData.description && <Popup
          trigger={<Icon name="info circle" />}
          content={eventTypeData.description}
          size="mini"
        />}
      </Dropdown.Item>
    );

    let selectedEventName = this.props.selectedEventName;
    if (_.isEmpty(selectedEventName)) {
      selectedEventName = 'Choose event type';
    }

    return (
      <Dropdown className="rule-menu" text={selectedEventName} simple>
        <Dropdown.Menu className="right">
          {/* Search Input */}
          <div style={{ padding: '8px', borderBottom: '1px solid #e8e8e8' }}>
            <Input
              icon="search"
              iconPosition="left"
              placeholder="Search events..."
              value={searchQuery}
              onChange={this.handleSearchChange}
              style={{ width: '100%' }}
            />
          </div>
          {isSearchMode ? (
            // Flat search results mode
            <React.Fragment>
              {this.getFilteredFlatOptions().length === 0 ? (
                <Dropdown.Item disabled>
                  <em>No results found for &quot;{searchQuery}&quot;</em>
                </Dropdown.Item>
              ) : (
                this.getFilteredFlatOptions().map(renderEventItem)
              )}
            </React.Fragment>
          ) : (
            // Original nested structure mode
            <React.Fragment>
              {_.map(this.props.eventTypesObject.eventGroups, (val, key) => (
                <Dropdown.Item key={key}>
                  <Icon name="triangle right" />
                  <span className="text">{key}</span>
                  <Dropdown.Menu className="right">
                    {_.map(val, renderEventItem)}
                  </Dropdown.Menu>
                </Dropdown.Item>
              ))}
              {_.map(this.props.eventTypesObject.rootEventTypes, renderEventItem)}
            </React.Fragment>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
